class Errors {
    /**
     * Create a new FormErrors instance.
     *
     * @param errors
     */
    constructor(fields = {}) {
        for (let field in fields) {
            this[field] = null
        }
    }

    /**
     * Determine if the given field has a validation error.
     *
     * @param field
     */
    has(field) {
        return this.hasOwnProperty(field) && this[field] && this[field] !== null
    }

    /**
     *  Count how many errors
     *
     *  @return Number
     */
    count() {
        let counter = 0

        for (let field in this) {
            if (this.has(field)) counter++
        }

        return counter
    }

    /**
     * Get the error message of the given field.
     *
     * @param field
     * @returns {*}
     */
    get(field) {
        if (this[field]) {
            return Array.isArray(this[field]) && this[field].length == 1 ? this[field][0] : this[field]
        }
    }

    /**
     * Record the new errors.
     *
     * @param {object} errors
     */
    record({ errors }) {
        for (let key in errors) {
            this[key] = errors[key][0]
        }
    }

    /**
     * Clear error on a specific field or all errors.
     *
     * @param field
     */
    clear(field) {
        if (this[field]) {
            this[field] = null
            return
        }

        if (!field) {
            for (let key in this) {
                this[key] = null
            }
        }
    }
}

class Form {
    /**
     * Create a new Form instance.
     *
     * @param fields
     * @param name
     */
    constructor(fields = {}) {
        this.fields = fields
        this.errors = new Errors(fields)
        this.message = {}

        for (let field in fields) {
            this[field] = fields[field]
        }
    }

    payload() {
        let payload = {}

        for (let property in this.fields) {
            payload[property] = this[property]
        }

        return payload
    }

    reset(fields) {
        if (typeof fields == 'string') {
            this[fields] = this.fields[fields]

            return
        }

        if (typeof fields == 'object') {
            for (let i = 0; i < fields.length; i++) {
                this[fields[i]] = this.fields[fields[i]]
            }

            return;
        }

        for (let field in this.fields) {
            if (Array.isArray(this.fields[field])) {
                this[field] = []
                this.fields[field] = []
            } else {
                this[field] = this.fields[field]
            }
        }
    }

    set(object) {
        for (let key in object) {
            if (this.hasOwnProperty(key)) {
                this[key] = typeof object[key] !== 'undefined' ? object[key] : this.fields[key]
            }
        }
    }

    get(key) {
        return this[key]
    }

    has(key) {
        return this[key]
    }

    setMessage(message) {
        if (message !== null && typeof message === 'object') {
            return this.message = message
        }
    }

    resetMessage() {
        this.message = {}
    }
}

export default Form